<template>
  <table class="nationality-table">
    <thead>
      <tr>
        <th colspan="3" class="header-nationality">By Student Nationality</th>
        <th class="header-qty text-center">Qty</th>
      </tr>
    </thead>
    <tbody :class="type === 'personal' ? 'personal' : 'office'">
      <tr v-if="isLoading">
        <td class="text-center">Loading data...</td>
      </tr>

      <tr v-if="!isLoading && !nationalities.length">
        <td class="text-center">Students not found</td>
      </tr>

      <tr v-else v-for="(nationality, index) in nationalities" :key="index">
        <td class="number">{{ index + 1 }}</td>
        <td class="flag">
          <img :src="nationality.flag_url" :alt="nationality.country" class="flag-image" />
        </td>
        <td class="country-name">{{ nationality.country }}</td>
        <td class="students-qty">
          <span class="badge badge-qty">{{ nationality.students_qty }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'StudentNationality',
  props: {
    type: {
      type: String,
      default: 'office'
    },
    nationalities: {
      type: Array,
      default: () => []
    }
  },
  created() {
    if (this.nationalities.length > 0) {
      this.isLoading = false;
    }
  },
  data() {
    return {
      isLoading: true
    };
  },
  watch: {
    nationalities(value) {
      this.isLoading = false;
    }
  }
}
</script>